/**
 * Standard Text Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initStandardText() {
        const blocks = document.querySelectorAll('.standard-text');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] standard-text block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStandardText);
    } else {
        initStandardText();
    }
})();